// alterado - revisado

const tipoFamiliarHistoricoSaudeFamiliaresList = [
    {
        id: 'P',
        descricao: 'Pai',
        ordem: 10,
    },
    {
        id: 'M',
        descricao: 'Mãe',
        ordem: 20,
    },
    {
        id: 'I',
        descricao: 'Irmãs(os)',
        ordem: 30,
    },
]

export default tipoFamiliarHistoricoSaudeFamiliaresList
